import { useState } from "react";
import { registerAdmin } from "../store/action";
import { dispatch, useDispatch } from "react-redux";

function NewAdmin() {
  const dispatch = useDispatch()
  const [newAdminInput, setNewAdminInput] = useState({
    username: '',
    email: '',
    password: '',
    phoneNumber: '',
    address: ''
  })

  const handleChange = (e) => {
    const {value, name} = e.target
    const input = {
      ... newAdminInput,
      [name]: value
    }
    setNewAdminInput(input)
    console.log(input, "<<<")
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(registerAdmin(newAdminInput))
    setNewAdminInput({
      username: '',
      email: '',
      password: '',
      phoneNumber: '',
      address: ''
    })
  }


  return (
    <section style={{height: "100vh"}}>
      <h1 className="py-5">Create New Admin</h1>
      <form>
        <div className="mb-3 row px-3">
          <div className="col-2">
            <label className="form-label mr-5"> Username </label>
          </div>

          <div className="col">
            <input onChange={handleChange} value={newAdminInput.username}
              type="text" className="form-control w-75 mx-3" name="username" />
          </div>
        </div>
        <div className="mb-3 row px-3">
          <div className="col-2">
            <label className="form-label mr-5"> Email </label>
          </div>
          <div className="col">
            <input onChange={handleChange} value={newAdminInput.email}
              type="text" className="form-control w-75 mx-3" name="email" />
          </div>
        </div>
        <div className="mb-3 row px-3">
          <div className="col-2">
            <label className="form-label mr-5"> Password </label>
          </div>
          <div className="col">
            <input onChange={handleChange} value={newAdminInput.password}
              type="password" className="form-control w-75 mx-3" name="password" />
          </div>
        </div>
        <div className="mb-3 row px-3">
          <div className="col-2">
            <label className="form-label mr-5"> Phone Number </label>
          </div>
          <div className="col">
            <input onChange={handleChange} value={newAdminInput.phoneNumber}
              type="tel" className="form-control w-75 mx-3" name="phoneNumber" />
          </div>
        </div>
        <div className="mb-3 row px-3">
          <div className="col-2">
            <label className="form-label mr-5"> Address </label>
          </div>
          <div className="col">
            <input onChange={handleChange} value={newAdminInput.address}
              type="text" className="form-control w-75 mx-3" name="address" />
          </div>          
        </div>
        <div className="row px-5 py-3">
            <button onClick={handleSubmit} className="btn btn-primary " type="submit">Submit</button>
          </div>
      </form>
    </section>
  );
}

export default NewAdmin;
